<template>
  <section class="wrapper">
    <van-form @submit="save">
      <van-field
        is-link
        input-align="right"
        v-model="applyInfo.Post.text"
        label="发起岗位"
        placeholder="请选择"
        readonly
        :rules="[{ required: true, message: '请先设置用户岗位' }]"
        @click="showPostPicker=true"
      />
      <van-field
        input-align="right"
        v-model="applyInfo.summary"
        rows="1"
        autosize
        label="审批事由"
        type="textarea"
      />
      <van-collapse v-model="activeNames">
        <div class="van-remove-detail-items" v-for="(detail,index) in applyInfo.details" :key="index">
          <label class="van-remove-detail" v-if="index>0"><i class="iconfont iconfont-guanbi iconfont-style" @click="removeDetails(index)"></i></label>
          <van-collapse-item :title="`出差明细${index+1}`" :name="index">
            <van-field
              is-link
              input-align="right"
              v-model="detail.DtsInvType"
              label="出差类别"
              placeholder="请选择"
              readonly
              :rules="[{ required: true, message: '请选择类别' }]"
              @click="detail.showWindows.showBusinessType=true"
            />
            <van-field
              is-link
              class="mt10"
              input-align="right"
              v-model="detail.BeginDate"
              label="开始时间"
              readonly
              placeholder="请选择"
              @click="detail.showWindows.showStartDate=true"
              :rules="[{ required: true, message: '请选择开始时间' }]"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.EndDate"
              label="结束时间"
              readonly
              placeholder="请选择"
              @click="detail.showWindows.showEndDate=true"
              :rules="[{ required: true, message: '请选择结束时间' }]"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.FromLocationName"
              label="始发地"
              readonly
              placeholder="请选择"
              @click="showMap(detail,1)"
              :rules="[{ required: true, message: '请选择始发地' }]"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.Destination"
              label="目的地"
              readonly
              placeholder="请选择"
              @click="showMap(detail,2)"
              :rules="[{ required: true, message: '请选择目的地' }]"
            />
            <van-field
              input-align="right"
              v-model="detail.LocationName"
              label="目的地名称"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入目的地名称' }]"
            />
            <van-field
              input-align="right"
              v-model="detail.subsidyAmt"
              label="出差时长"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入时长' }]"
            />
            <van-field
              is-link
              input-align="right"
              v-model="detail.DtsInvTypeUnit"
              label="单位"
              readonly
              placeholder="请选择"
              @click="detail.showWindows.showTakeTimeUnit=true"
              :rules="[{ required: true, message: '请选择单位' }]"
            />
            <van-field
              class="mt10"
              input-align="right"
              v-model="detail.Remark"
              rows="4"
              autosize
              label="出差事由"
              type="textarea"
              placeholder="请输入出差事由"
            />
            <van-field class="mt10" input-align="right" label="说明附件">
              <template #input>
                <van-uploader v-model="detail.uploader" :after-read="(file)=>{
                  //自行上传文件
                  detail.uploader.forEach((item, index) => {
                    //此时可以自行将文件上传至服务器
                    fileUpload(item.file,detail).then(response=>{
                      if (response.success) {
                          detail.fileList.push({
                          frGuid: response.frGuid,
                          A_GUID: response.A_GUID,
                          FileName: response.FileName,
                          ImgOcr: response.ImgOcr
                        })
                      }
                      else{
                        $toast.fail('上传失败');
                      }
                    });
                  })
                }" multiple>
                  <van-button size="small" icon="plus" round plain type="primary"/>
                </van-uploader>
              </template>
            </van-field>
            <!--开始日期-->
            <van-popup v-model="detail.showWindows.showStartDate" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                :max-date="detail.maxDate"
                :formatter="dateTimeHalfAnHourFormatter"
                :filter="dateTimeHalfAnHourFilter"
                @cancel="detail.showWindows.showStartDate=false"
                @confirm="()=>{
                  detail.minDate=addMinutesHalfAnHourTime(currentDate,30);
                  detail.BeginDate = moment(currentDate).format('YYYY/MM/DD HH:mm');
                  detail.showWindows.showStartDate=false
                }"
              />
            </van-popup>
            <!--结束日期-->
            <van-popup v-model="detail.showWindows.showEndDate" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                :min-date="detail.minDate"
                :formatter="dateTimeHalfAnHourFormatter"
                :filter="dateTimeHalfAnHourFilter"
                @cancel="detail.showWindows.showEndDate=false"
                @confirm="()=>{
                  detail.maxDate=addMinutesHalfAnHourTime(currentDate,-30);
                  detail.EndDate = moment(currentDate).format('YYYY/MM/DD HH:mm');
                  detail.showWindows.showEndDate=false
                }"
              />
            </van-popup>
            <!--出差类型-->
            <van-popup v-model="detail.showWindows.showBusinessType" round position="bottom">
              <van-picker
                show-toolbar
                :columns="businessTypeList"
                @cancel="detail.showWindows.showBusinessType = false"
                @confirm="(item,index)=>{
                  detail.DtsInvType=item.value;
                  detail.showWindows.showBusinessType = false
                }"
              />
            </van-popup>
            <!--出差时长单位-->
            <van-popup v-model="detail.showWindows.showTakeTimeUnit" round position="bottom">
              <van-picker
                show-toolbar
                :columns="businesTimeUnitList"
                @cancel="detail.showWindows.showTakeTimeUnit = false"
                @confirm="(item,index)=> {
                  detail.DtsInvTypeUnit=item.value;
                  detail.showWindows.showTakeTimeUnit = false;
                }"
              />
            </van-popup>
        </van-collapse-item>
        </div>
      </van-collapse>
      <div class="add-detail" @click="addDetails"><i class="iconfont iconfont-zengjia"></i>添加明细</div>
    <div class="pr5 pl5">
      <van-button block type="info">提交</van-button>
    </div>
    </van-form>
    <!--岗位弹框-->
    <van-popup v-model="showPostPicker" round position="bottom">
    <van-picker
      show-toolbar
      :columns="postList"
      @cancel="showPostPicker = false"
      @confirm="onPost"
    />
  </van-popup>
    <!--高德地图弹框-->
    <van-popup v-model="showAMapModal" closeable round position="bottom">
      <template>
        <div class="row">
            <div class="row-container">
              <div class="form-group">
                  <div class="col-md-12">
                    <van-field
                      is-link
                      input-align="left"
                      class="custom-field"
                      v-model="selectedAddress"
                      label="选择城市"
                      readonly
                      placeholder="请选择国家城市"
                      @click="showCountryCityPicker=true"
                    />
                  </div>
              </div>
            </div>
          <div class="row-container">
              <div class="form-group">
                  <div class="col-md-12">
                    <van-field
                      input-align="left"
                      class="custom-field"
                      v-model="areaAddress"
                      label="详细地址"
                      placeholder="输入街道等详细地址"
                    />
                  </div>
              </div>
          </div>
          <div class="row-container">
            <div class="col-md-12">
              <div class="form-group">
                <div class="col-md-12">
                  <van-button block type="primary" v-show="isMapSearchShow" @click="SearchOfficeAddress()">搜索地址</van-button>
                </div>
              </div>
            </div>
          </div>
          <div id="mapContainer" class="row-container mt10" v-show="isMapSearchShow">
            <div id="map-container" class="col-md-12" style="height: 20rem;"></div>
            <div id="panel" class="col-md-12"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="wc-btn wc-btn-primary" @click="SaveLocation()">
              提交
            </button>
            <button type="button" class="wc-btn wc-btn-primary ghost" @click="showAMapModal=false">
              关闭
            </button>
          </div>
        </div>
      </template>
    </van-popup>
    <!--城市弹框-->
    <van-popup v-model="showCountryCityPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="countryCityList"
        @cancel="showCountryCityPicker = false"
        @change="dataChange"
        @confirm="confirmCountryCity"
      />
    </van-popup>
  </section>
</template>

<script>
  import {getUserPostListApi, submitApplyFormApi} from '@/api/reimbursement'
  import {getStatffOfficeAddrApi,getAddressListApi,getProcessApprovalUsersApi, fileUploadApi} from '@/api/common'
  export default {
    data() {
      return {
        isShow: true,//是否显示
        isMapSearchShow:true,//是否显示地图
        showPostPicker: false,//弹出岗位弹框
        showCountryCityPicker: false,//弹出国家城市弹框
        showAMapModal: false,//弹出高德地图
        countryCityList: [],//国家城市数据
        currentDate: new Date(),//当前日期
        applyInfo: {
          Post: {text: '', value: ''},//发起岗位
          summary: '',//请假事由
          details: [{
            GUID: this.guid(),//生成唯一的GUID
            DtsInvType: '',//出差类型
            BeginDate: '',//开始时间
            EndDate: '',//结束时间
            minDate:new Date((new Date().getFullYear()-10)+"-01-01 00:00"),//最小日期设置为当前时间
            maxDate:new Date((new Date().getFullYear()+10)+"-12-31 23:59"),//最大日期设置为当前时间
            FromCity: '',//始发城市
            FromArea: '',//始发地区
            FromDestination: '',//始发地
            FromLocationName:'',//始发地点名称
            FromLongitude: '',//始发地经纬度（经度）
            FromLatitude: '',//始发地经纬度（纬度）
            City:'',//目的地城市
            Area: '',//目的地地区
            Destination: '',//目的地
            LocationName: '',//目的地名称
            Longitude: '',//目的地经纬度（经度）
            Latitude: '',//目的地经纬度（纬度）
            Remark: '',//出差事由
            subsidyAmt: '',//出差时长
            DtsInvTypeUnit: '天',//时长单位
            uploader: [],//需要上传的文件
            //弹框对象
            showWindows: {
              showBusinessType: false,
              showStartDate: false,
              showEndDate: false,
              showTakeTimeUnit: false,
            },
          }],
        },
        postList: [
          {text: "", value: ""}
        ],//岗位列表
        //出差类别
        businessTypeList: [{
          text: '出国',
          value: '出国'
        }, {
          text: '出省',
          value: '出省'
        }, {
          text: '出市',
          value: '出市'
        }, {
          text: '本地',
          value: '本地'
        }, {
          text: '居家办公',
          value: '居家办公'
        }],
        //请假单位列表
        businesTimeUnitList: [{
          text: '天',
          value: '天'
        }, {
          text: '小时',
          value: '小时'
        }],
        activeNames: [0],//请假明细分组名称
        mapContainer:null,
        //审批人列表
        followList: [],
        placeSearch:null,
        handleType:null,
        categoryType:'',//指定分类：1-始发地 2-目的地
        addressList:[],//地址列表
        selectedCountry: {value:'',text:''},//选择的国家
        selectedProvince: {value:'',text:''},//选择的省份
        selectedCity: {value:'',text:''},//选择的城市
        selectedAddress: '',//选择的城市地址
        cityValue: '',//选择的高德城市名称
        areaValue: '',//选择的高德城市地区
        areaAddress: '',//输入的详细地址
        realAddress: '',//选择的高德详细地址
        realLocationName:'',//选择的高德地点名称
        areaLongitude:'',//经纬度(经度)
        areaLatitude:'',//经纬度(纬度)
        config: {
          key: '749238a22308fd82317ce29340a824bc',
          securityJsCode: '40e8135d9f45d89f3cb482edd41fbde0',
          version: '2.0', // API版本
          plugins: ['AMap.Geolocation', 'AMap.AutoComplete','AMap.PlaceSearch']
        }
      }
    },
    mounted() {
      this.getAddressList();
      this.getStatffOfficeAddr(this.applyInfo.details[0]);
      this.getUserPostList();
    },
    methods: {
      //获取地址列表
      async getAddressList() {
        let params = {};
        let response = await getAddressListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.addressList = response.result;
          }
        }
      },
      //获取员工办公地点
      async getStatffOfficeAddr(details) {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID
        };
        let response = await getStatffOfficeAddrApi(params);
        if (response.success) {
          if (response.code === "0000") {
            if(response.result!==undefined&&response.result!==null&&response.result.length>0) {
              let item = response.result[0];
              this.$set(details, 'FromCity', item.City);
              this.$set(details, 'FromArea', item.Area);
              this.$set(details, 'FromDestination', item.DetailedAddress);
              this.$set(details, 'FromLocationName', item.LocationName);
              this.$set(details, 'FromLongitude', item.Longitude);
              this.$set(details, 'FromLatitude', item.Latitude);
            }
          }
        }
      },
      //获取用户岗位列表
      async getUserPostList() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID
        };
        let response = await getUserPostListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let arr = new Array();
            response.result.forEach(function (item, index) {
              let data = new Object();
              data.text = item.PostName;
              data.value = item.GUID;
              arr.push(data);
            });
            if (arr != undefined && arr != null && arr.length > 0) {
              this.postList = arr;
              this.$set(this.applyInfo.Post, 'value', arr[0].value);
              this.$set(this.applyInfo.Post, 'text', arr[0].text);
            }
          }
        }
      },
      //选择岗位
      onPost(item) {
        this.$set(this.applyInfo.Post, 'value', item.value);
        this.$set(this.applyInfo.Post, 'text', item.text);
        this.$set(this, 'showPostPicker', false);
      },
      //上传至服务器
      async fileUpload(file, detail) {
        //此时可以自行将文件上传至服务器
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let formData = new FormData();
        formData.append("cGuid", companyInfo.companyId);
        formData.append("uGuid", userInfo.U_GUID);
        formData.append("frGuid", detail.GUID);
        formData.append("TempFileNameFirst", "1");
        formData.append("Type", "OCR");
        formData.append("sequence", detail.GUID);
        formData.append("RelationType", "FT");
        formData.append("scanType", "");
        formData.append("categoryGuid", "74FD3D28-B288-465A-9059-4A267D030878");
        formData.append("isTemp", "true");
        formData.append("file", file);
        return await fileUploadApi(formData);
      },
      //增加出差明细
      addDetails() {
        this.applyInfo.details.push({
          GUID: this.guid(),//生成唯一的GUID
          DtsInvType: '',//出差类型
          BeginDate: '',//开始时间
          minDate:new Date((new Date().getFullYear()-10)+"-01-01 00:00"),//最小日期设置为当前时间
          maxDate:new Date((new Date().getFullYear()+10)+"-12-31 23:59"),//最大日期设置为当前时间
          EndDate: '',//结束时间
          FromCity: '',//始发城市
          FromArea: '',//始发地区
          FromDestination: '',//始发地
          FromLocationName:'',//始发地点名称
          FromLongitude: '',//始发地经纬度（经度）
          FromLatitude: '',//始发地经纬度（纬度）
          City: '',//目的地城市
          Area: '',//目的地地区
          Destination: '',//目的地
          LocationName: '',//目的地名称
          Longitude: '',//目的地经纬度（经度）
          Latitude: '',//目的地经纬度（纬度）
          Remark: '',//出差事由
          subsidyAmt: '',//出差时长
          DtsInvTypeUnit: '天',//时长单位
          uploader: [],//需要上传的文件
          fileList: [],//存储上传的文件
          //弹框对象
          showWindows: {
            showBusinessType: false,
            showStartDate: false,
            showEndDate: false,
            showTakeTimeUnit: false,
          },
        })
        if(this.applyInfo.details!==undefined&&this.applyInfo.details!==null&&this.applyInfo.details.length>0) {
          this.activeNames = [this.applyInfo.details.length - 1];
        }
      },
      //移除报销明细
      removeDetails(index) {
        this.applyInfo.details.splice(index, 1);
        if(this.applyInfo.details!==undefined&&this.applyInfo.details!==null&&this.applyInfo.details.length>0) {
          this.activeNames = [this.applyInfo.details.length - 1];
        }
      },
      showMap(details,type) {
        this.$set(this, 'showAMapModal', true);
        this.$set(this, 'handleType', details);
        this.$set(this, 'categoryType', type);
        this.$nextTick(() => { // 确保DOM已更新后执行初始化地图的代码
          let arr = new Array();
          this.addressList.filter(o => o.level === 1).forEach(function (item, index) {
            let data = new Object();
            data.text = item.areaValue;
            data.value = item.id;
            arr.push(data);
          });
          this.$set(this, 'countryList', arr);
          if (arr != undefined && arr != null && arr.length > 0) {
            this.$set(this.selectedCountry, 'value', arr[0].value);
            this.$set(this.selectedCountry, 'text', arr[0].text);
            let province=this.getProvinceByCountryChosen(arr[0].value);
            let city=this.getCityByProvinceChosen(province[0].value);
            this.countryCityList = [{values: arr}, {values: province}, {values: city}];
            this.initMap(arr[0].value); // 初始化地图的方法
          }
        });
      },
      //初始化高德地图
      initMap(countryValue) {
        // 清空搜索结果面板
        let panel = document.getElementById("panel");
        if (panel) panel.innerHTML = ""; // 直接清空DOM内容
        this.$set(this, 'isMapSearchShow', false);
        if (countryValue === 1 || countryValue === 504 || countryValue === 505 || countryValue === 1874) {
          this.$set(this, 'isMapSearchShow', true);
          //设置你的安全密钥
          window._AMapSecurityConfig = {
            securityJsCode: '40e8135d9f45d89f3cb482edd41fbde0',
          };
          var url = 'https://webapi.amap.com/maps?v=2.0&key=749238a22308fd82317ce29340a824bc&callback=onLoad';
          var jsapi = document.createElement("script");
          jsapi.src = url;
          document.head.appendChild(jsapi);
          //声明异步加载回调函数
          window.onLoad = function () {
            this.mapContainer = new AMap.Map("map-container");//"container"为<div>容器的id
          }
        }
        //重置
        this.ResetFormFields();
      },
      //重置选择的地图信息
      ResetFormFields() {
        // 重置所有输入框
        this.$set(this, 'areaAddress', '');
        this.$set(this, 'areaLongitude', '');
        this.$set(this, 'areaLatitude', '');
        this.$set(this, 'realAddress', '');
        this.$set(this, 'realLocationName', '');
        this.$set(this.selectedProvince, 'value', '');
        this.$set(this.selectedProvince, 'text', '');
        this.$set(this.selectedCity, 'value', '');
        this.$set(this.selectedCity, 'text', '');
        this.$set(this, 'selectedAddress', '');
        // 清空搜索结果面板
        let panel = document.getElementById("panel");
        if (panel) panel.innerHTML = ""; // 直接清空DOM内容
      },
      dataChange(picker, value,index) {
        if(index===0) {
          let province = this.getProvinceByCountryChosen(value[0].value);
          picker.setColumnValues(1, province);
          if (province !== undefined && province !== null && province.length > 0) {
            let city = this.getCityByProvinceChosen(province[0].value);
            picker.setColumnValues(2, city);
          } else {
            picker.setColumnValues(2, []);
          }
          this.initMap(value[0].value); // 初始化地图的方法
        }
        else if(index===1){
          let city = this.getCityByProvinceChosen(value[1].value);
          if (city !== undefined && city !== null && city.length > 0) {
            picker.setColumnValues(2, city);
          } else {
            picker.setColumnValues(2, []);
          }
        }
      },
      //根据选择的国家获取省份
      getProvinceByCountryChosen(id) {
        let arr = new Array();
        this.addressList.filter(o => o.parentId === id).forEach(function (item, index) {
          let data = new Object();
          data.text = item.areaValue;
          data.value = item.id;
          arr.push(data);
        });
        return arr;
      },
      //选择省份获取城市数据
      getCityByProvinceChosen(id) {
        let arr = new Array();
        this.addressList.filter(o => o.parentId === id).forEach(function (item, index) {
          let data = new Object();
          data.text = item.areaValue;
          data.value = item.id;
          arr.push(data);
        });
        return arr;
      },
      //选择的城市信息
      confirmCountryCity(item) {
        this.$set(this.selectedCountry, 'value', `${item[0].value}`);
        this.$set(this.selectedCountry, 'text', `${item[0].text}`);
        this.$set(this.selectedProvince, 'value', `${item[1].value ? item[1].value : ''}`);
        this.$set(this.selectedProvince, 'text', `${item[1].text ? item[1].text : ''}`);
        this.$set(this.selectedCity, 'value', `${item[2].value ? item[2].value : ''}`);
        this.$set(this.selectedCity, 'text', `${item[2].text ? item[2].text : ''}`);
        this.$set(this, 'selectedAddress', `${item[0].text}${item[1].text ? item[1].text: ''}${item[2].text ? item[2].text : ''}`);
        this.showCountryCityPicker = false;
      },
      //搜索办公地址
      SearchOfficeAddress() {
        let that = this;
        let SearchCountry = this.selectedCountry.text;
        let SearchProvince = this.selectedProvince.text;
        let SearchCity = this.selectedCity.text;
        let CityList = this.cityList;
        if ((SearchCountry === undefined || SearchCountry === null || SearchCountry === "" || SearchCountry.length < 1)
          || (SearchProvince === undefined || SearchProvince === null || SearchProvince === "" || SearchProvince.length < 1)
          || (CityList != undefined && CityList != null && CityList.length > 0 && (SearchCity == undefined || SearchCity == null || SearchCity == "" || SearchCity.length < 1))) {
          this.$toast.fail('请输入城市名');
          return;
        }
        let SearchAddress = this.areaAddress;
        if (SearchAddress === undefined || SearchAddress === null || SearchAddress === "" || SearchAddress.length < 1) {
          this.$toast.fail('请输入街道等详细地址');
          return;
        }
        let cityName=(CityList === undefined || CityList === null || CityList.length < 1 ? (SearchProvince === undefined || SearchProvince === null && SearchProvince === "" || SearchProvince.length < 1 ? "" : SearchProvince) : (SearchCity === undefined || SearchCity === null && SearchCity === "" || SearchCity.length < 1 ? "" : (SearchProvince === "北京" || SearchProvince === "上海" || SearchProvince === "天津" || SearchProvince === "重庆" ? SearchProvince : SearchCity)));
        AMap.plugin(["AMap.PlaceSearch"], () => {
          //构造地点查询类
          let placeSearch = new AMap.PlaceSearch({
            pageSize: 5, // 单页显示结果条数
            pageIndex: 1, // 页码
            city: cityName,
            citylimit: true,  //是否强制限制在设置的城市内搜索
            map: mapContainer, // 展现结果的地图实例
            panel: "panel", // 结果列表将在此容器中进行展示。
            autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          });
          // 执行搜索（移除原回调函数）
          placeSearch.search((SearchCountry === undefined || SearchCountry === null && SearchCountry === "" || SearchCountry.length < 1 ? "" : SearchCountry) + (SearchProvince === undefined || SearchProvince === null && SearchProvince === "" || SearchProvince.length < 1 ? "" : SearchProvince) + (SearchCity === undefined || SearchCity === null && SearchCity === "" || SearchCity.length < 1 ? "" : SearchCity) + SearchAddress);
          // 新增事件监听：当用户点击结果列表时
          placeSearch.on('selectChanged', (e) => {
            if (e.selected && e.selected.data) {
              let poi = e.selected.data;
              let fullAddress = [
                poi.pname,
                poi.cityname,
                poi.adname,
                poi.address
              ].filter(Boolean).join(''); // 自动过滤空值
              this.$set(this, "cityValue", poi.cityname);
              this.$set(this, "areaValue", poi.adname);
              this.$set(this, "areaAddress", fullAddress);
              this.$set(this, "realAddress", fullAddress);
              this.$set(this, "realLocationName", poi.name);
              this.$set(this, "areaLongitude", poi.location.lng);
              this.$set(this, "areaLatitude", poi.location.lat);
            }
          });
        });
      },
      //提交办公地址
      SaveLocation() {
        let SearchCountry = this.selectedCountry.value;
        if (SearchCountry == 1 || SearchCountry == 504 || SearchCountry == 505 || SearchCountry == 1874) {
          let myCity = this.cityValue;
          let myArea = this.areaValue;
          let myAddress = this.areaAddress;
          let realAddress = this.realAddress;
          let realLocationName=this.realLocationName;
          if (myAddress === undefined || myAddress === null || myAddress === "" || myAddress.length < 1) {
            this.$toast.fail('请输入详细街道等地址！');
            return;
          }
          let Longitude = this.areaLongitude;
          let Latitude = this.areaLatitude;
          if ((Longitude === undefined || Longitude === null || Longitude === "" || Longitude.length < 1) && (Latitude === undefined || Latitude === null || Latitude === "" || Latitude.length < 1)) {
            this.$toast.fail('请先选择高德搜索结果有效地址！');
            return;
          }
          if (myAddress !== realAddress) {
            this.$toast.fail('输入的详细街道等地址与选择的地址不一致！');
            return;
          }

          let details = this.handleType;
          let type = this.categoryType;
          if (type === 1) {
            this.$set(details, "FromCity", myCity);
            this.$set(details, "FromArea", myArea);
            this.$set(details, "FromDestination", realAddress);
            this.$set(details, "FromLocationName", realLocationName);
            this.$set(details, "FromLongitude", Longitude);
            this.$set(details, "FromLatitude", Latitude);
          } else if (type === 2) {
            this.$set(details, "City", myCity);
            this.$set(details, "Area", myArea);
            this.$set(details, "Destination", realAddress);
            this.$set(details, "Longitude", Longitude);
            this.$set(details, "Latitude", Latitude);
          }
          this.$set(this, "showAMapModal", false);
        } else {
          let myCity = this.cityValue;
          let myArea = this.areaValue;
          let myAddress = this.areaAddress;
          if (myAddress === undefined || myAddress === null || myAddress === "" || myAddress.length < 1) {
            this.$toast.fail('请输入详细街道等地址！');
            return;
          }
          let details = this.handleType;
          let type = this.categoryType;
          if (type === 1) {
            this.$set(details, "FromCity", myCity);
            this.$set(details, "FromArea", myArea);
            this.$set(details, "FromDestination", myAddress);
            this.$set(details, "FromLocationName", myAddress);
            this.$set(details, "FromLongitude", '');
            this.$set(details, "FromLatitude", '');
          } else if (type === 2) {
            this.$set(details, "City", myCity);
            this.$set(details, "Area", myArea);
            this.$set(details, "Destination", myAddress);
            this.$set(details, "Longitude", '');
            this.$set(details, "Latitude", '');
          }
          this.$set(this, "showAMapModal", false);
        }
      },
      //提交表单
      async save() {
        this.isShow = false;
        let postGuid = this.applyInfo.Post.value;
        let approvalGuid = this.guid();
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let paylist = new Array();
        this.applyInfo.details.forEach((v, i) => {
          let approvalDetailGuid = v.GUID;
          let beginDate = v.BeginDate;
          let endDate = v.EndDate;
          let fromCity = v.FromCity;//始发城市
          let fromArea = v.FromArea;//始发地区
          let fromDestination = v.FromDestination;//始发地
          let fromLocationName = v.FromLocationName;//始发地点名称
          let fromLongitude = v.FromLongitude;//始发地经纬度（经度）
          let fromLatitude = v.FromLatitude;//始发地经纬度（纬度）
          let city = v.City;//出差城市
          let area = v.Area;//出差地区
          let destination = v.Destination;//出差目的地
          let locationName = v.LocationName;//出差目的地地点名称
          let longitude = v.Longitude;//经纬度（经度）
          let latitude = v.Latitude;//经纬度（纬度）
          let subsidyAmt = v.subsidyAmt.replace(/,/g, "");
          let invTypeDts = v.DtsInvType;
          let invTypeUnit = v.DtsInvTypeUnit;
          let remark = v.Remark;
          let pay = new Object;
          pay.Approval_GUID = approvalGuid;
          pay.Approval_Sub_GUID = approvalDetailGuid;
          pay.FormType = 'FT';
          pay.BeginDate = beginDate;
          pay.EndDate = endDate;
          pay.FromCity = fromCity;
          pay.FromArea = fromArea;
          pay.FromDestination = fromDestination;
          pay.FromLocationName = fromLocationName;
          pay.FromLongitude = fromLongitude;
          pay.FromLatitude = fromLatitude;
          pay.City = city;
          pay.Area = area;
          pay.Destination = destination;
          pay.LocationName = locationName;
          pay.Longitude = longitude;
          pay.Latitude = latitude;
          pay.InvTypeDts = invTypeDts;
          pay.Remark = remark;
          pay.Post_GUID = postGuid;
          pay.SumLeave = subsidyAmt;
          pay.LeaveType = invTypeDts;
          pay.LeaveTypeUnit = invTypeUnit;
          pay.C_GUID = companyInfo.companyId;
          paylist.push(pay);
        });
        let approvalFormInfo = new Object;
        approvalFormInfo.Approval_GUID = approvalGuid;
        approvalFormInfo.FormType = 'FT';
        approvalFormInfo.Post_GUID = postGuid;
        approvalFormInfo.Remark = this.applyInfo.summary;
        approvalFormInfo.C_GUID = companyInfo.companyId;
        approvalFormInfo.U_GUID = userInfo.U_GUID;
        approvalFormInfo.Creator = userInfo.NickName;
        approvalFormInfo.CompanyName = companyInfo.companyName;
        approvalFormInfo.UserName = userInfo.TelName || userInfo.LoginName;
        approvalFormInfo.ApplyName = userInfo.NickName || (userInfo.FirstName + userInfo.LastName);
        approvalFormInfo.detailFLLists = paylist;
        let params = {
          ...approvalFormInfo
        };
        let response = await submitApplyFormApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.isShow = true;
            this.$router.push({path: "/follow"})
            return;
          }
          this.$toast.fail(response.msg);
          return;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    height: calc(100vh - 5rem);
    ::v-deep.van-hairline--top-bottom{
      .van-remove-detail-items {
        position: relative;
        height: 100%;
        .van-remove-detail {
          display: flex;
          position: absolute;
          right: 3rem;
          z-index: 5;
          text-align: center;
          align-items: center;
          padding: 10px 16px;
          line-height: 24px;
          color: #0066ff;
          font-size: 1.4rem;
          .iconfont-style{
            font-size:1.1rem;
          }
        }
      }
    }
    .add-detail {
      color: #0066ff;
      text-align: center;
      padding: 1rem 0;
      font-size: 1.4rem;
    }
    ::v-deep.van-field__error-message{
      text-align: right;
    }
    ::v-deep.van-collapse-item__content {
      padding: 0;
    }

    ::v-deep.van-collapse-item__title {
      background: #f6f6f8;
    }
    .user-card {
      display: inline-flex;
      padding: 5px;
      color: black;
      font-size: 1.6rem;
      background: #f3f3f3;
      flex-direction: row;
      align-items: center;
      margin-top: 1rem;
      vertical-align: middle;
      margin-right: 1rem;

      &-profile {
        width: 3.5rem;
        height: 3.5rem;
      }
    }
    ::v-deep.row {
       overflow: initial;
      width:95%;
      margin:5rem auto 2rem;
      clear: both;
      .row-container{
        width:100%;
        clear: both;
        overflow: hidden;
      }
      .col-md-6 {
        width: 50%;
        float: left;
      }
      .form-group {
        margin-bottom: 15px;
      }
      .ml10 {
        margin-left: 10px !important;
      }
      .mt10 {
        margin-top: 10px !important;
      }
      .input-group-addon, .input-group-btn {
        white-space: nowrap;
        vertical-align: middle;
      }
      .input-group-addon {
        min-width: auto;
        height:100%;
        display: block;
        padding: 6px 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        color: #555;
        text-align: left;
        background-color: #fff;
        border: 0 none;
        border-radius: 4px;
      }

      .col-md-1 {
        width: 8.33333333%;
        float: left;
      }
      .col-md-2 {
        width: 16.66666667%;
        float: left;
      }
      .col-md-3 {
        width: 25%;
        float: left;
      }
      .col-md-4 {
        width: 33.33333333%;
        float: left;
      }
      .col-md-5 {
        width: 41.66666667%;
        float: left;
      }
      .col-md-8 {
        width: 66.66666667%;
        float: left;
      }
      .col-md-9 {
        width: 75%;
        float: left;
      }
      .col-md-11 {
        width: 91.66666667%;
        float: left;
      }
      .col-md-12 {
        width: 100%;
      }
      .custom-field{
        border:1px solid #ccc;
      }
      .modal-footer {
        padding: 10px 15px 10px 15px !important;
        border-top: solid 1px #e2e2e2 !important;
        text-align: right;
      }
      .modal-footer::before {
        display: table;
        content: "";
      }
      .wc-btn {
        display: inline-block;
        padding: 0 10px;
        height: 30px;
        line-height: 28px;
        border-width: 1px;
        border-style: solid;
        font-size: 12px;
        box-sizing: border-box;
        outline: none;
        white-space: nowrap;
      }
      .wc-btn-primary {
        color: white;
        background-color: #217346;
        border-color: #217346;
      }
      .wc-btn-primary.ghost {
        background-color: white;
        color: #217346;
        margin-left: 6px;
      }
     }
    ::v-deep.row::before {
      display: table;
      content: "";
    }
  }
</style>
